module.exports = __webpack_public_path__ + "img/CN.8be86c14.svg";